module.exports = __webpack_public_path__ + "media/lifestyle_home/Kantro_book_hp_300x140-165ed02b.png";